import Vue from 'vue'
import Vuex from 'vuex'
import {autoMutations } from '@/plugins/vuexUtils.js'
import { vuexfireMutations, firestoreAction } from 'vuexfire'
Vue.use(Vuex);

import '@/plugins/vueLogger.js'

import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

import { db } from "@/plugins/firebase.js"

export const store = new Vuex.Store(autoMutations({
  strict: false,
  namespaced: false,
  state: {

    loginUser: null,
    loginUserBinded: false,

    adminDevices: null,
    adminDevicesBinded: false,

    friendDevices: null,
    friendDevicesBinded: false,

    oAdminDevices: null,
    oAdminDevicesBinded: false,

    notLoginConfirmed: false,

    loginUserOpen: false,
    loginUserDeepBinding: false,

    currentUser: null,
    providerId: null,
    isNewUser: false,

    // editProfileFloatShow: false,
    // updatePasswordFloatShow: false,
    // changeEmailAddressFloatShow: false,

    presentationMode: false,
    showPresentationModeEscapeButton: true,
    chartonlyMode: false,

  },
  getters: {

    loginUserDeviceGroupByFolder: (state, getters) => {
      let result = {};
      if(!state.loginUser || !state.loginUserBinded) {
        return result;
      }
      else {
        state.loginUser.folders.forEach(folder=> {
          result[folder] = [];
        })
        result["@root"] = [];
        for(let device in state.loginUser.devices) {
          result[(state.loginUser.foldersInfo[device].folder)? state.loginUser.foldersInfo[device].folder: "@root"].push(state.loginUser.devices[device]);
        }
        return result;
      }
    },

    loginUserDeviceInfoGroupByFolder: (state, getters) => {
      let result = {};
      if(!state.loginUser || !state.loginUserBinded) {
        return result;
      }
      else {
        result["@root"] = [];
        state.loginUser.folders.forEach(folder=> {
          result[folder] = [];
        })
        for(let device in state.loginUser.foldersInfo) {
          if(state.loginUser.devices[device]) {
            if(state.loginUser.foldersInfo[device].folder == "") {
              if(state.loginUser.foldersInfo[device].name) {
                result["@root"].push({
                  id: device,
                  name: state.loginUser.foldersInfo[device].name,
                  index: state.loginUser.foldersInfo[device].index,
                });
              }
              else {
                result["@root"].push({
                  id: device,
                  index: state.loginUser.foldersInfo[device].index,
                });
              }
            }
            else if(typeof(result[state.loginUser.foldersInfo[device].folder]) != "undefined") {
              if(state.loginUser.foldersInfo[device].name) {
                result[state.loginUser.foldersInfo[device].folder].push({
                  id: device,
                  name: state.loginUser.foldersInfo[device].name,
                  index: state.loginUser.foldersInfo[device].index
                });
              }
              else {
                result[state.loginUser.foldersInfo[device].folder].push({
                  id: device,
                  index: state.loginUser.foldersInfo[device].index
                });
              }

            }
            else {

              if(state.loginUser.foldersInfo[device].name) {
                result["@root"].push({
                  id: device,
                  index: state.loginUser.foldersInfo[device].index,
                  name: state.loginUser.foldersInfo[device].name,
                  error: true
                });
              }
              else {
                result["@root"].push({
                  id: device,
                  index: state.loginUser.foldersInfo[device].index,
                  error: true
                });
              }

            }

          }
          else {
            store.dispatch("storeRemoveDeviceFromFoldersInfo", device);
          }
        }
        if(result["@root"].length !=0) {
          result["@root"] = result["@root"].sort((a,b)=> a.index-b.index);
          result["@root"].forEach((item, position) => {
            item.index = position;
            state.loginUser.foldersInfo[item.id].index = position;
          })
        }
        state.loginUser.folders.forEach(folder=> {
          if(result[folder].length !=0) {
            result[folder] = result[folder].sort((a,b)=> a.index-b.index);
            result[folder].forEach((item, position) => {
              item.index = position;
              state.loginUser.foldersInfo[item.id].index = position;
            })
          }
        })
        return result;
      }
    },

    loginUserDeviceArrayAll: (state, getters) => {
      let result = getters.loginUserDeviceArray;
      if(state.adminDevices != null) {
        result = result.concat(state.adminDevices);
      }
      return result;
    },

    loginUserDeviceArray: (state, getters) => {
      let result = [];
      if(!state.loginUser || !state.loginUserBinded) {
        return result;
      }
      for(let deviceId in state.loginUser.devices) {
        result.push(state.loginUser.devices[deviceId]);
      }
      return result;
    },

    loginUserDeviceListAll: (state, getters) => {
      let result = getters.loginUserDeviceList;
      if(state.adminDevices != null) {
        state.adminDevices.forEach(device => {
          result[device.id] = device;
        })
      }
      return result;
    },

    loginUserAdminDeviceList: (state, getters) => {
      let result = {};
      if(state.adminDevices != null) {
        state.adminDevices.forEach(device => {
          result[device.id] = device;
        })
      }
      return result;
    },

    loginUserDeviceList: (state, getters) => {
      let result = {};
      if(!state.loginUser || !state.loginUserBinded) {
        return result;
      }
      else {
        for(let deviceId in state.loginUser.devices) {
          result[deviceId] = state.loginUser.devices[deviceId];
        }
        return result;
      }
    },

    loginUserSensorArrayAll: (state, getters) => {
      let result = [];
      getters.loginUserDeviceArrayAll.forEach(device => {
        for(let sensorName in device.sensors) {
          result.push(device.sensors[sensorName]);
        }
      })
      return result;
    },

    loginUserSensorArrayAllHasData: (state, getters) => {
      return getters.loginUserSensorArrayAll.filter(sensor=> sensor.lastValues != null);
    },

    loginUserSensorArray: (state, getters) => {
      let result = [];
      getters.loginUserDeviceArray.forEach(device => {
        for(let sensorName in device.sensors) {
          result.push(device.sensors[sensorName]);
        }
      })
      return result;
    },

    loginUserSensorArrayHasData: (state, getters) => {
      return getters.loginUserSensorArray.filter(sensor=> sensor.lastValues != null);
    }
  },

  mutations: vuexfireMutations,
  actions: {

    storeBindingOAdminDevices: firestoreAction((context) => {
      return context.bindFirestoreRef(
        "oAdminDevices",
        db.collection("/devices").where("oAdmin", "==", firebase.auth().currentUser.uid), {
          maxRefDepth: 2,
          reset: false
        }
      );
    }),

    storeUnbindingOAdminDevices: firestoreAction((context) => {
      return context.unbindFirestoreRef('oAdminDevices', false);
    }),

    storeBindingFriendDevices: firestoreAction((context) => {
      return context.bindFirestoreRef(
        "friendDevices",
        db.collection("/devices").where("frApp", "array-contains", firebase.auth().currentUser.uid), {
          maxRefDepth: 2,
          reset: false
        }
      );
    }),

    storeUnbindingFriendDevices: firestoreAction((context) => {
      return context.unbindFirestoreRef('friendDevices', false);
    }),

    storeUnbindingAdminDevices: firestoreAction((context) => {
      return context.unbindFirestoreRef('adminDevices', false);
    }),

    storeBindingAdminDevices: firestoreAction((context) => {
      return context.bindFirestoreRef(
        "adminDevices",
        db.collection("/devices").where("admin", "==", firebase.auth().currentUser.uid),
        {maxRefDepth: 1}
      )
    }),

    storeRemoveDeviceFromFoldersInfo: firestoreAction((context, deviceId) => {
      console.log(deviceId);
      return db.collection('/users').doc(context.state.loginUser.id).update({
        ["foldersInfo." + deviceId]: firebase.firestore.FieldValue.delete()
      })
    }),

    storeBindingLoginUserRef : firestoreAction((context, depth) => {
      return context.bindFirestoreRef(
        "loginUser",
        db.collection("/users").doc(firebase.auth().currentUser.uid),
        {maxRefDepth: depth}
      )
      .then(() => {
        if(depth == 2) {
          store.dispatch("storeBindingAdminDevices");
        }
      })
    }),

    storeUnbindingLoginUserRef: firestoreAction(context => {
      return context.unbindFirestoreRef('loginUser')
    }),

    storeSaveFolder: firestoreAction(context => {
      return db.collection("users").doc(context.state.currentUser.uid).update({
        "folders": context.state.loginUser.folders,
        "foldersInfo": context.state.loginUser.foldersInfo,
      })
    }),

    storeSaveFriends: firestoreAction(context => {
      let batch = db.batch();
      if(context.state.loginUserDeepBinding) {
        let did, sName;
        for(did in context.state.loginUser.devices) {
          if(context.state.loginUser.devices[did].inherit) {
            batch.update(db.collection("devices").doc(did), {
              "frApp": context.state.loginUser.frApp,
              "frAppCache": context.state.loginUser.frAppCache,
            })
          }
          for(sName in context.state.loginUser.devices[did].sensors) {
            batch.update(db.collection("sensors").doc(context.state.loginUser.devices[did].sensors[sName].id), {
              "frApp": context.state.loginUser.frApp,
              "frAppCache": context.state.loginUser.frAppCache,
            })
          }
        }
        batch.update(db.collection("users").doc(context.state.currentUser.uid), {
          "frApp": context.state.loginUser.frApp,
          "frAppCache": context.state.loginUser.frAppCache,
          "frReq": context.state.loginUser.frReq,
        })
        return batch.commit()
      }
      else {
        return db.collection("sensors").where("owner", "==", context.state.currentUser.uid).where("inherit", "==", true)
        .get()
        .then(sensorList => {
          sensorList.forEach(sensor => {
            batch.update(db.collection("sensors").doc(sensor.id), {
              "frApp": context.state.loginUser.frApp,
              "frAppCache": context.state.loginUser.frAppCache
            })
          })
          db.collection("devices").where("owner", "==", context.state.currentUser.uid).where("inherit", "==", true)
          .get()
          .then(deviceList => {

            deviceList.forEach(device => {
              batch.update(db.collection("devices").doc(device.id), {
                "frApp": context.state.loginUser.frApp,
                "frAppCache": context.state.loginUser.frAppCache
              })
            })

            batch.update(db.collection("users").doc(context.state.currentUser.uid), {
              "frApp": context.state.loginUser.frApp,
              "frAppCache": context.state.loginUser.frAppCache,
              "frReq": context.state.loginUser.frReq,
            })

            batch.commit()
          })
        })
      }
    }),

    storeSaveChartOptions: firestoreAction(context => {
      return db.collection("users").doc(context.state.currentUser.uid).update({
        "chartOptions": context.state.loginUser.chartOptions,
      })
    }),

    storeSaveBookmark: firestoreAction(context => {
      return db.collection("users").doc(context.state.currentUser.uid).update({
        "bookmarks": context.state.loginUser.bookmarks,
      })
    }),

    storeSaveLoginUserProfile: firestoreAction(context => {

      if(context.state.loginUserOpen != context.state.loginUser.open) {
        let batch = db.batch();
        let sensors = db.collection("sensors").where("owner", "==", context.state.currentUser.uid)
        return sensors.get()
        .then(sensorList => {
          sensorList.forEach(doc => {
            batch.update(db.collection("sensors").doc(doc.id), {
              open: context.state.loginUser.open,
            })
          })
          batch.update(db.collection("users").doc(context.state.currentUser.uid),{
            "displayName": context.state.loginUser.displayName ,
            "description": context.state.loginUser.description ,
            "photoURL": context.state.loginUser.photoURL,
            "emailVerified": context.state.loginUser.emailVerified,
            "open": context.state.loginUser.open,
            "deepBinding": context.state.loginUser.deepBinding,
            "openEmail": context.state.loginUser.openEmail,
            "openFriends": context.state.loginUser.openFriends,
            "openBookmark": context.state.loginUser.openBookmark,
            "folders": context.state.loginUser.folders,
            "foldersInfo": context.state.loginUser.foldersInfo,
            "frApp": context.state.loginUser.frApp,
            "frAppCache": context.state.loginUser.frAppCache,
            "frReq": context.state.loginUser.frReq,
          })
          for(let item in context.state.loginUser.devices) {
            batch.update(db.collection("devices").doc(item), {
              open: context.state.loginUser.open,
            })
          }
          batch.commit()
          .then(() => {
            context.state.loginUserOpen = context.state.loginUser.open
            if(context.state.loginUserDeepBinding != context.state.loginUser.deepBinding) {
              context.state.loginUserDeepBinding = context.state.loginUser.deepBinding
              store.dispatch("storeBindingLoginUserRef", {maxRefDepth: (context.state.loginUserDeepBinding)? 2: 0});
            }
          })
        })
      }
      else {
        db.collection("users").doc(context.state.currentUser.uid).update({
          "displayName": context.state.loginUser.displayName ,
          "description": context.state.loginUser.description ,
          "photoURL": context.state.loginUser.photoURL,
          "emailVerified": context.state.loginUser.emailVerified,
          "open": context.state.loginUser.open,
          "deepBinding": context.state.loginUser.deepBinding,
          "openEmail": context.state.loginUser.openEmail,
          "openFriends": context.state.loginUser.openFriends,
          "openBookmark": context.state.loginUser.openBookmark,
          "folders": context.state.loginUser.folders,
          "foldersInfo": context.state.loginUser.foldersInfo,
          "frApp": context.state.loginUser.frApp,
          "frAppCache": context.state.loginUser.frAppCache,
          "frReq": context.state.loginUser.frReq,
        })
        .then(() => {
          if(context.state.loginUserDeepBinding != context.state.loginUser.deepBinding) {
            context.state.loginUserDeepBinding = context.state.loginUser.deepBinding
            store.dispatch("storeBindingLoginUserRef", {maxRefDepth: (context.state.loginUser.deepBinding)? 2: 0});
          }
        })
      }
    }),

    storeSaveUiDeviceMap: firestoreAction((context, user) => {
      return db.collection('/users').doc(user.id).update({
        "ui_devicemap_location": user.ui_devicemap_location ,
        "ui_devicemap_zoom": user.ui_devicemap_zoom ,
        "ui_devicemap_popupFontSize": user.ui_devicemap_popupFontSize,
      })
    }),

    storeRemoveUiDeviceMap: firestoreAction((context, user) => {
      return db.collection('/users').doc(user.id).update({
        "ui_devicemap_location": null,
        "ui_devicemap_zoom": 0 ,
        "ui_devicemap_popupFontSize": 0,
      })
    }),

    storeSaveLoginUserEmailVerified : firestoreAction(context => {
      return db.collection('/users').doc(firebase.auth().currentUser.uid).update({
        "emailVerified": context.state.loginUser.emailVerified,
      })
    }),

    storeSaveLoginUserEmail: firestoreAction(context => {
      return db.collection('/users').doc(firebase.auth().currentUser.uid).update({
        "email": context.state.loginUser.email,
        "emailVerified": context.state.loginUser.emailVerified,
      })
    }),

  },
}))
